export const interest = {
  ZERO: [0, "0%", 0],
  ONE: [0.01, "1%", 1],
  ONE_POINT_FIVE: [0.015, "1.5%", 1.5],
  TWO: [0.02, "2%", 2],
  TWO_POINT_FIVE: [0.025, "2.5%", 2.5],
  THREE: [0.03, "3%", 3],
  THREE_POINT_FIVE: [0.035, "3.5%", 3.5],
  FOUR: [0.04, "4%", 4],
  FOUR_POINT_FIVE: [0.045, "4.5%", 4.5],
  FIVE: [0.05, "5%", 5],
  FIVE_POINT_FIVE: [0.055, "5.5%", 5.5],
  SIX: [0.06, "6%", 6],
  SIX_POINT_FIVE: [0.065, "6.5%", 6.5],
  SEVEN: [0.07, "7%", 7],
  SEVEN_POINT_FIVE: [0.075, "7.5%", 7.5],
  EIGHT: [0.08, "8%", 8],
  EIGHT_POINT_FIVE: [0.085, "8.5%", 8.5],
  NINE: [0.09, "9%", 9],
  NINE_POINT_FIVE: [0.095, "9.5%", 9.5],
  TEN: [0.1, "10%", 10],
  TEN_POINT_FIVE: [0.105, "10.5%", 10.5],
  ELEVEN: [0.11, "11%", 11],
  ELEVEN_POINT_FIVE: [0.115, "11.5%", 11.5],
  TWELVE: [0.12, "12%", 12],
  TWELVE_POINT_FIVE: [0.125, "12.5%", 12.5],
  THIRTEEN: [0.13, "13%", 13],
  THIRTEEN_POINT_FIVE: [0.135, "13.5%", 13.5],
  FOURTEEN: [0.14, "14%", 14],
  FOURTEEN_POINT_FIVE: [0.145, "14.5%", 14.5],
  FIFTEEN: [0.15, "15%", 15],
  FIFTEEN_POINT_FIVE: [0.155, "15.5%", 15.5],
  SIXTEEN: [0.16, "16%", 16],
  SIXTEEN_POINT_FIVE: [0.165, "16.5%", 16.5],
  SEVENTEEN: [0.17, "17%", 17],
  SEVENTEEN_POINT_FIVE: [0.175, "17.5%", 17.5],
  EIGHTTEEN: [0.18, "18%", 18],
  EIGHTTEEN_POINT_FIVE: [0.185, "18.5%", 18.5],
  NINETEEN: [0.19, "19%", 19],
  NINETEEN_POINT_FIVE: [0.195, "19.5%", 19.5],
  TWENTY: [0.2, "20%", 20],
  TWENTY_POINT_FIVE: [0.205, "20.5%", 20.5],
  TWENTYONE: [0.21, "21%", 21],
  TWENTYONE_POINT_FIVE: [0.215, "21.5%", 21.5],
  TWENTYTWO: [0.22, "22%", 22],
  TWENTYTWO_POINT_FIVE: [0.225, "22.5%", 22.5],
  TWENTYTHREE: [0.23, "23%", 23],
  TWENTYTHREE_POINT_FIVE: [0.235, "23.5%", 23.5],
  TWENTYFOUR: [0.24, "24%", 24],
};

export const getSelectOptions = (list) =>
  Object.entries(list).map(([key, [value, label, fill]]) => ({
    value,
    label,
    fill,
  }));

export const optionsInterest = [...getSelectOptions(interest)];
